/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createGenusDtoFromDiscriminatorValue, type GenusDto } from '../../models/index.js';
// @ts-ignore
import { createODataErrorFromDiscriminatorValue, type ODataError } from '../../models/oDataErrors/index.js';
// @ts-ignore
import { CoolingRegimeGenusRequestBuilderNavigationMetadata, CoolingRegimeGenusRequestBuilderRequestsMetadata, type CoolingRegimeGenusRequestBuilder } from './coolingRegimeGenus/index.js';
// @ts-ignore
import { CropRequestBuilderNavigationMetadata, CropRequestBuilderRequestsMetadata, type CropRequestBuilder } from './crop/index.js';
// @ts-ignore
import { SpeciesRequestBuilderNavigationMetadata, SpeciesRequestBuilderRequestsMetadata, type SpeciesRequestBuilder } from './species/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Provides operations to manage the collection of GenusDto entities.
 */
export interface WithGenusItemRequestBuilder extends BaseRequestBuilder<WithGenusItemRequestBuilder> {
    /**
     * Provides operations to manage the coolingRegimeGenus property of the AapService.GenusDto entity.
     */
    get coolingRegimeGenus(): CoolingRegimeGenusRequestBuilder;
    /**
     * Provides operations to manage the crop property of the AapService.GenusDto entity.
     */
    get crop(): CropRequestBuilder;
    /**
     * Provides operations to manage the species property of the AapService.GenusDto entity.
     */
    get species(): SpeciesRequestBuilder;
    /**
     * Get entity from GenusOverview by key
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<GenusDto>}
     * @throws {ODataError} error when the service returns a 4XX or 5XX status code
     */
     get(requestConfiguration?: RequestConfiguration<WithGenusItemRequestBuilderGetQueryParameters> | undefined) : Promise<GenusDto | undefined>;
    /**
     * Get entity from GenusOverview by key
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<WithGenusItemRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Get entity from GenusOverview by key
 */
export interface WithGenusItemRequestBuilderGetQueryParameters {
    /**
     * Expand related entities
     */
    expand?: string[];
    /**
     * Select properties to be returned
     */
    select?: string[];
}
/**
 * Uri template for the request builder.
 */
export const WithGenusItemRequestBuilderUriTemplate = "{+baseurl}/GenusOverview/{genusId}{?%24expand,%24select}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const WithGenusItemRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "expand": "%24expand",
    "select": "%24select",
};
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithGenusItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithGenusItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    coolingRegimeGenus: {
        requestsMetadata: CoolingRegimeGenusRequestBuilderRequestsMetadata,
        navigationMetadata: CoolingRegimeGenusRequestBuilderNavigationMetadata,
    },
    crop: {
        requestsMetadata: CropRequestBuilderRequestsMetadata,
        navigationMetadata: CropRequestBuilderNavigationMetadata,
    },
    species: {
        requestsMetadata: SpeciesRequestBuilderRequestsMetadata,
        navigationMetadata: SpeciesRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithGenusItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: WithGenusItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            XXX: createODataErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createGenusDtoFromDiscriminatorValue,
        queryParametersMapper: WithGenusItemRequestBuilderGetQueryParametersMapper,
    },
};
/* tslint:enable */
/* eslint-enable */
